import { AiSettings } from '@/modules/ai-features/views/ai-settings'

export const AiSettingsPage = () => {
  return <AiSettings />
}
